<div id="wrapper">
	<div>
		<app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
	</div>
	<div>
		<app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
			(updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
			(updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
			(updateInitializeData)="this.initializeData()">
		</app-tab-nav>
	</div>
	<div style="margin-bottom: 0px;">
		<app-tab-nav></app-tab-nav>
	</div>
	<div class="allcont logsize m-top-i">
		<div class="basicrow ">
			<div class="container">
				<div class="basicr-line-i">
					<div class="fulltitle  f-btitle autodef">
						<span class="icon-dash-13"></span> Soporte Técnico <a class="ClaroTv">Claro</a><a class="tvmas">tv+</a>
					</div>
				</div>
			</div>
		</div>
		<div class="basicrow roboto-r f-med f-black">
			<div class="container m-top-i">
				<div class="row ">
					<div class="basicrow">
						<div class="support-general-box">
							<div class="support-contact-box">
								<div class="center-items logo-box">
									<img class="logo-box-img" src="/assets/images/ico_contactanos.png">
								</div>
								<div class="info-box">
									<div class="basicrow f-big roboto-l">
										Contáctanos
									</div>
									<br><br>
									<div class="b-r-gray">
										<span class="roboto-b">Horario de Servicio al Cliente</span>
										<br class="off"><br>
										<span>Lunes a Viernes: 8:00 a.m - 7:00 p.m</span>
										<br>
										<span>Sábados y Domingos: 8:00 a.m - 5:00 p.m</span>
										<br>
										<span>Días Feriados: 8:00 a.m - 5:00 p.m</span>
										<br><br>
										<span class="roboto-b">Horario de Servicio al Cliente</span>
										<br>
										<span>
											Servicio al Cliente PRT: 787-775-0000.
										</span>
									</div>
								</div>
							</div>
							<div class="support-bot-box">
								<div class="center-items logo-box">
									<img class="logo-box-img" src="/assets/images/ico-claro-bot.png">
								</div>
								<div class="info-box">
									<div class="basicrow f-big roboto-l">
									</div>
									<br class="off"><br>
									<span class="roboto-b">Claro Bot</span>
									<br class="off-bot"><br>
									<span>Chat disponible las 24 horas.</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="basicrow m-top-i graybg">
			<div class="container ">
				<div class="grid-1">
					<div>
						<div class="basicrow f-big roboto-l">
							Centro de Ayuda <a class="ClaroTv">Claro</a><a class="tvmas">tv+</a>
						</div>
					</div>
					<div>
						<a target="_blank" rel="noopener noreferrer" href="assets/pdf/soporte_iptv.pdf" class="linkdefs">Ver Guía rápida</a>
					</div>
					<!-- <div class="grid-two-column">
						<div>
							<div class="basicrow f-bmed roboto-b">
								Lorem ipsum dolor sit amet, consectetur adipisicing elit.
							</div>
							<div class="basicrow f-med line-def-i m-top-ii" style="text-align: justify;">
								Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quam dolorem
								laboriosam maiores vitae laudantium non voluptate. Atque, quidem dolorem!
								Laboriosam eum perferendis hic dolor aperiam quam repudiandae, doloremque
								minima! Excepturi?
							</div>
						</div>
						<div>
							<div class="basicrow h-mtop f-bmed roboto-b">
								Lorem ipsum dolor sit amet, consectetur adipisicing elit.
							</div>
							<div class="basicrow f-med line-def-i m-top-ii" style="text-align: justify;">
								Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolor, officiis neque
								at voluptates est consequatur similique. Maiores laborum ducimus numquam
								inventore iste fuga quis amet! Sed iste rerum eos quia.
							</div>
						</div>
					</div> -->
				</div>
				<!-- <div class="basicrow m-top-ii">
					<div class="row">
						<div #comp1 class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-lg-offset-4 col-md-offset-3">
							<a href="https://help.IPTV.com/es" target="_blank" class="btns blue vcenter">
								<span class="tabcell">
									Ir a Soporte de <a class="ClaroTv">Claro</a><a class="tvmas">tv+</a> &nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
								</span>
							</a>
						</div>
					</div>
				</div> -->
			</div>
		</div>
	</div>
	<app-footer></app-footer>
</div>
